import axios from '@/utils/axios';

export const byDocumentType = async (type, admin_id) => {
  const response = await axios.get(`/document-settings/${type}/${admin_id}`);
  return response;
};

export const createOrUpdate = async (payload) => {
  const response = await axios.post('/document-settings/create', payload);
  return response;
};
